<template>
  <div class="slider-list">
    <div class="slider" ref="slider" @click.stop="handelClickSlider">
      <div class="process" :style="{ width, background: bgColor }"></div>
      <div class="thunk" ref="trunk" :style="{ left }">
        <div class="block" ref="dot"></div>
      </div>
    </div>
    <div class="kd d-flex d-flex-aic d-flex-jc-sb">
      <div class="item">
        <span>{{ min }}个</span>
      </div>
      <div class="item">
        <span>{{ middle }}个</span>
      </div>
      <div class="item">
        <span>{{ max }}个</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
/*
 * min 进度条最小值
 * max 进度条最大值
 * v-model 对当前值进行双向绑定实时显示拖拽进度
 * */
export default {
  props: {
    // 最小值
    min: {
      type: Number,
      default: 0,
    },
    // 最大值
    max: {
      type: Number,
      default: 100,
    },
    // 当前值
    value: {
      type: Number,
      default: 0,
    },
    // 进度条颜色
    bgColor: {
      type: String,
      default: "#1da83b",
    },
    // 是否可拖拽
    isDrag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      slider: null, //滚动条DOM元素
      thunk: null, //拖拽DOM元素
      per: this.value, //当前值
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.slider = this.$refs.slider;
      this.thunk = this.$refs.trunk;
      var _this = this;
      if (!this.isDrag) return;
      if (!this._isMobile()) {
        this.thunk.onmousedown = function (e) {
          var width = parseInt(_this.width);
          var disX = e.clientX;
          document.onmousemove = function (e) {
            // value, left, width
            // 当value变化的时候，会通过计算属性修改left，width
            // 拖拽的时候获取的新width
            var newWidth = e.clientX - disX + width;
            // 计算百分比
            var scale = newWidth / _this.slider.offsetWidth;
            _this.per = Math.ceil((_this.max - _this.min) * scale + _this.min); //取整
            // 限制值大小
            _this.per = Math.max(_this.per, _this.min);
            _this.per = Math.min(_this.per, _this.max);

            _this.$emit("inputData", _this.per);
          };
          document.onmouseup = function () {
            //当拖拽停止发送事件
            _this.$emit("stop", _this.per);
            //清除拖拽事件
            document.onmousemove = document.onmouseup = null;
          };
        };
      } else {
        var width = parseInt(_this.width);
        var disX = 0;
        this.thunk.ontouchstart = function (e) {
          width = parseInt(_this.width);
          disX = e.touches[0].clientX;
          console.log(disX);
        };
        var handleDrag = function (e) {
          // value, left, width
          // 当value变化的时候，会通过计算属性修改left，width
          // 拖拽的时候获取的新width
          var newWidth = e.touches[0].clientX - disX + width;
          // 计算百分比
          var scale = newWidth / _this.slider.offsetWidth;
          _this.per = Math.ceil((_this.max - _this.min) * scale + _this.min); //取整
          // 限制值大小
          _this.per = Math.max(_this.per, _this.min);
          _this.per = Math.min(_this.per, _this.max);
          _this.$emit("inputData", _this.per);
        };
        this.thunk.addEventListener("touchmove", handleDrag);
        this.thunk.addEventListener("touchend", () => {
          document.removeEventListener("touchmove", handleDrag);
        });
      }
    },
    handelClickSlider(event) {
      //禁止点击
      if (!this.isDrag) return;
      const dot = this.$refs.dot;
      if (event.target == dot) return;
      //获取元素的宽度l
      let width = this.slider.offsetWidth;
      //获取元素的左边距
      let ev = event || window.event;
      //获取当前点击位置的百分比
      let scale = ((ev.offsetX / width) * 100).toFixed(2);
      this.per = scale;
    },
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
  computed: {
    // 设置一个百分比，提供计算slider进度宽度和trunk的left值
    // 对应公式为  当前值-最小值/最大值-最小值 = slider进度width / slider总width
    // trunk left =  slider进度width + trunk宽度/2
    scale() {
      return (this.per - this.min) / (this.max - this.min);
    },
    width() {
      return this.slider ? this.slider.offsetWidth * this.scale + "px" : "0px";
    },
    left() {
      return this.slider
        ? this.slider.offsetWidth * this.scale -
            this.thunk.offsetWidth / 2 +
            "px"
        : "0px";
    },
    middle() {
      return this.max / 2;
    },
    ...mapState({
      windowW: (state) => state.config.windowW,
    }),
  },
  watch: {
    value: {
      handler: function () {
        this.per = this.value;
      },
    },
    windowW(newVal, oldVal) {
      this.slider = null;
      this.thunk = null;
      this.per = 1;
      this.$emit("inputData", 1);
      this.load();
      console.log(this.slider);
    },
  },
};
</script>

<style lang="less" scoped>
.slider {
  position: relative;
  width: 100%;
  height: 8px;
  top: 50%;
  background: #b2e3c2;
  border-radius: 5px;
  cursor: pointer;
  z-index: 99999;
  .process {
    position: absolute;
    left: 0;
    top: 0;
    width: 112px;
    height: 8px;
    border-radius: 5px;
    background: #1da83b;
    z-index: 111;
  }
  .thunk {
    position: absolute;
    left: 100px;
    top: -12px;
    width: 20px;
    height: 35px;
    z-index: 122;
  }
  .block {
    width: 20px;
    height: 35px;
    background: url(../assets/images/icon14.png) center center no-repeat;
    &:hover {
      opacity: 0.9;
    }
  }
}
.kd {
  position: relative;
  .item {
    margin: 0;
    position: relative;
    text-align: center;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      width: 2px;
      height: 13px;
      background: #666;
    }
  }
  span {
    display: block;
    margin-top: 20px !important;
    font-size: 14px;
    color: #333;
  }
}
</style>
